import request from '../utils/request';


export const PlanAPI = {

    /**
    * 查询订单列表
    */
    queryPlans(params) {
        return request({
            url: "/api/plans",
            method: "get",
            params
        })
    }
}


// WEBPACK FOOTER //
// ./src/api/plan.js